import { useMemo } from 'react';
import { UI_MODE } from 'framework-listing-lib/constants';
import { useHistory } from 'react-router-dom';
import { getDashboardFolderRoute } from 'FormsUI/lib/RouteGenerators';
const useFrameworkUIModeProps = () => {
  const history = useHistory();
  const uiMode = window.location.href.indexOf('/folders') !== -1 ? UI_MODE.FOLDERS : UI_MODE.LIST;
  const uiModeProps = useMemo(() => ({
    currentUIMode: uiMode,
    onChangeUIMode: (mode = UI_MODE.LIST) => history.push(getDashboardFolderRoute(mode))
  }), [uiMode, history]);
  return uiModeProps;
};
export default useFrameworkUIModeProps;